import type { CreateFundingRequestPrivateDto } from '@/api/kubik/credit'
import type { TApplyFinancingOfferHandlerOptions } from '@/components/composed/financing/types'
import { isNonNullable } from '@/typeguards/common'
import type { EFinancingProductId } from '@/types'

export const mapApplyFinancingOfferHandlerOptionsToDto = ({
  body,
  isLeasing,
}: TApplyFinancingOfferHandlerOptions): Omit<CreateFundingRequestPrivateDto, 'productIds'> & {
  productIds: EFinancingProductId[]
} => {
  const { productId, productIds, loanAmount, ...otherFields } = body

  const formattedProductIds = (isLeasing ? productIds : [productId])?.filter(isNonNullable) ?? []
  const validLoanAmount = isNaN(Number(loanAmount?.value)) ? undefined : loanAmount

  return {
    ...otherFields,
    productIds: formattedProductIds,
    loanAmount: validLoanAmount,
  }
}
